export enum Dead {
  NONE = 'none',
  ICE = 'ice',
  ANIMAL = 'animal',
}

export interface stateType {
  currentLevel: number;
  isGame: boolean;
  isPause: boolean;
  dead: Dead;
  isWin: boolean;
  hasShared: boolean;
}
